// styles
import "../themes/common.scss";
import "../themes/css/pages/blog-page.scss";
//js
import "../themes/js/common.js";
// import "../themes/js/pages/home.js";
import "../themes/js/pages/blog-detail.js";

import { initmanage } from "../javascripts/component/manage.js";

initmanage();